export const ListQueryKey = 'diceCheckIns';
export const DetailQueryKey = 'diceCheckIn';

export const Urls = {
  selectUrl: '/DiceCheckIn/list',
  updateUrl: '/DiceCheckIn/update',
  deleteUrl: '/DiceCheckIn/delete',
  createUrl: '/DiceCheckIn/create',
  detailUrl: '/DiceCheckIn/info',
};
